"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTask = mapTask;
function formatDueDate(dateDue) {
    if (!dateDue)
        return "";
    var parsed = new Date(dateDue);
    if (Number.isNaN(parsed.getTime()))
        return "";
    return parsed.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
}
function mapTask(task) {
    var _a, _b, _c, _d;
    return {
        id: task.id,
        taskId: task.code,
        title: task.name || "Untitled Task",
        growCycle: (_b = (_a = task.growCycle) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : "",
        area: (_d = (_c = task.area) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
        motherPlant: task.motherPlant ? { id: task.motherPlant.id, name: task.motherPlant.name } : undefined,
        dueDate: formatDueDate(task.date_due),
        status: task.status || "OPEN",
        assignedTo: task.assigned_user ? { id: task.assigned_user.id, name: task.assigned_user.name } : undefined,
        canAssign: task.can_assign === true,
    };
}
